import { CALL_API } from '../middleware/ApiMiddleware';

export const SUPER_ADMIN_LOGIN_REQUEST = 'SUPER_ADMIN_LOGIN_REQUEST';
export const SUPER_ADMIN_LOGIN_SUCCESS = 'SUPER_ADMIN_LOGIN_SUCCESS';
export const SUPER_ADMIN_LOGIN_FAILURE = 'SUPER_ADMIN_LOGIN_FAILURE';

export const superAdminLogin = (agencyId: number) => ({
  [CALL_API]: {
    endpoint: `admin/agencies/${agencyId}/login`,
    body: {},
    method: 'post',
    authenticated: true,
    types: [SUPER_ADMIN_LOGIN_REQUEST, SUPER_ADMIN_LOGIN_SUCCESS, SUPER_ADMIN_LOGIN_FAILURE],
  },
});
